module.exports = __webpack_public_path__ + "img/binary-lock.4b0742a4.svg";